module.exports = __webpack_public_path__ + "static/media/29.ebac8813.png";